
export default {
  name: 'ListingMattressFinderProgress',
  props: {
    currentStep: {
      type: Number,
    },
    stepsLength: {
      type: Number,
      default() {
        return 3;
      },
    },
    stepsProgress: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  computed: {
    valueProgress() {
      const interval = 100 / (this.stepsLength - 1);
      return interval * (this.currentStep - 1);
    },
  },
};
